import React from "react";
import { ConfirmationModal } from "@veneer/core";
import { useTranslation } from "react-i18next";

const RejectConfirmationModal = ({ onHideModel, onReject, isModalShowing, data }) => {
const { t } = useTranslation();

    return (<>
        <>
            <ConfirmationModal
                id="reject-confirmation-modal"
                onConfirm={() => { onReject(); }}
                onClose={onHideModel}
                show={isModalShowing}
                title={t('desc_reject')}
            >

                <p>
                    {t('rejectSCs')}
                    <b> {data.join(', ')}</b>
                </p>

            </ConfirmationModal>
        </>
    </>);
}

export default  RejectConfirmationModal;

